import { render, staticRenderFns } from "./psconprepaySettle.vue?vue&type=template&id=18a57988&scoped=true"
import script from "./psconprepaySettle.vue?vue&type=script&lang=js"
export * from "./psconprepaySettle.vue?vue&type=script&lang=js"
import style0 from "./psconprepaySettle.vue?vue&type=style&index=0&id=18a57988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a57988",
  null
  
)

export default component.exports